import React from "react";

const buyers = [
  { name: "Meijer" },
  { name: "H&M" },
  { name: "Wal-Mart" },
  { name: "George" },
  { name: "Reitman's" },
  { name: "Colin's" },
  { name: "Koton" },
];

const Buyers = () => {
  return (
    <section className="py-20 border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14" data-aos="fade-up">
          <span className="text-xs uppercase tracking-widest font-bold text-[#EB4438] bg-red-50 px-3.5 py-1.5 rounded-full border border-red-100">
            Trusted Partnerships
          </span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-4 tracking-tight">
            OUR BUYERS
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-5">
          {buyers.map((v, i) => (
            <div
              key={i}
              className="group relative p-6 rounded-2xl bg-white border border-slate-200/80 shadow-sm hover:shadow-md hover:border-[#EB4438] hover:bg-slate-900 transition-all duration-300 cursor-pointer flex items-center justify-center min-h-[90px]"
              data-aos="zoom-in"
              data-aos-delay={i * 40}
            >
              <p className="text-center font-extrabold text-lg sm:text-2xl text-slate-800 group-hover:text-white transition-colors duration-300 tracking-tight">
                {v.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Buyers;

